import React from "react"
import {
  TestimonialCard,
  TestimonialImage,
  TestimonialName,
  TestimonialHiredAt,
  TestimonialStatement,
  CompanyImageContainer,
  CompanyImage,
  KeyLine,
  ImageContainer,
} from "./inline-testimonial.styles"

const InlineTestimonial = ({
  avatarImage,
  name,
  company,
  jobTitle,
  inlineStatement,
}) => (
  <TestimonialCard>
    <KeyLine />
    <ImageContainer>
      <TestimonialImage image={avatarImage.gatsbyImageData} alt={name} />
      <CompanyImageContainer>
        <CompanyImage
          src={company.file.url}
          alt={company.title}
          loading="lazy"
        />
      </CompanyImageContainer>
    </ImageContainer>

    <TestimonialName>{name}</TestimonialName>
    <TestimonialHiredAt>{jobTitle}</TestimonialHiredAt>
    <TestimonialStatement
      dangerouslySetInnerHTML={{
        __html: inlineStatement.childMarkdownRemark.html,
      }}
    />
  </TestimonialCard>
)

export default InlineTestimonial
